import { useDispatch } from 'react-redux'

import { TableList, TableColumns } from 'components/common'
import TenantApi, { getDetailUrl, pkField } from 'models/Tenant/api'
import { TenantActions } from 'models/Tenant/slice'
import { TenantCategoryValue } from 'models/TenantCategory/components'

import TenantValue from '../TenantValue'


const defaultColumnList = ['name', 'category', 'sort', 'isActive', 'actions'];


const TenantList = ({ columnList, params, filterParams, onEdit }) => {
  const [apiGetList, apiGetListProps] = TenantApi.endpoints.getTenantList.useLazyQuery();
  const [apiUpdate, apiUpdateProps] = TenantApi.endpoints.updateTenant.useMutation();
  const [apiDelete, apiDeleteProps] = TenantApi.endpoints.deleteTenant.useMutation();
  const [apiBatchDelete, apiBatchDeleteProps] = TenantApi.endpoints.batchDeleteTenant.useMutation();

  const dispatch = useDispatch();

  const fields = {
    name: {
      title: 'Название',
      sorter: true,
      render: (val, item) => (<TenantValue detail={item} asLink={true} isBack={true} />),
    },
    category: {
      title: 'Категория',
      width: 200,
      render: (val, item) => (<TenantCategoryValue detail={val} asLink={true} isBack={true} />),
    },
    sort: { title: 'Сортировка', sorter: true, width: 130 },
    isActive: TableColumns.getColumnOnOff({ title: 'Активно', fieldName: 'isActive', apiUpdate, apiUpdateProps }),

    actions: TableColumns.getColumnActions({
      getDetailUrl,
      getActions: (item) => [
        { name: 'edit', action: () => dispatch(TenantActions.openForm({ name: 'editForm', pk: item[pkField] })) },
        { name: 'delete', action: () => apiDelete(item[pkField]) },
      ]
    }),
  };

  return (
    <TableList
      queryKey="tenant"
      rowKey={pkField}
      params={params}
      filterParams={filterParams}
      fields={fields}
      columnList={columnList || defaultColumnList}

      apiGetList={apiGetList}
      apiGetListProps={apiGetListProps}
      apiUpdateProps={apiUpdateProps}
      apiDeleteProps={apiDeleteProps}
      apiBatchDelete={apiBatchDelete}
      apiBatchDeleteProps={apiBatchDeleteProps}
      onEdit={onEdit}

      rowSelection={false}
      hidePagination={false}
      hideStat={false}
    />
  );
}

export default TenantList;
